<template>
	<div class="headerWrapper">
		<header class="header">
			<div class="container">
				<el-menu theme="dark" :default-active="activeIndex" class="el-menu-header" mode="horizontal">
				  <el-menu-item index="1" class="home-link"><router-link to="/" exact><img class="logo" src="../assets/marca_logo.min.svg"></router-link></el-menu-item>
				  <el-menu-item index="2" v-if="auth.user !== null"><router-link to="/projects"><span>Projects</span></router-link></el-menu-item>
				  <!-- <el-menu-item index="3" v-if="auth.user !== null"><router-link to="/users"><span>Manage Users</span></router-link></el-menu-item> -->
<!-- 				  <el-menu-item index="4" v-if="auth.user !== null"><router-link to="/create-user"><span>Create User</span></router-link></el-menu-item>
 -->				  <el-submenu index="5" v-if="auth.user !== null">
				    <template slot="title">{{ auth.user.email }}</template><!-- user display name -->
						<el-menu-item index="5-1" @click="$router.push('/users')" v-if="userMeta.isAdmin == true">Manage Users</el-menu-item>
				    <el-menu-item index="5-2" @click="logOut()">Logout</el-menu-item><!-- firebase auth logout -->
				  </el-submenu>
				</el-menu>
			</div>
		</header>
	</div>
</template>
<script>
import { authService } from '../helpers/helpers'
import { mapState } from 'vuex'
export default {
  name: 'header',

  data () {
    return {
      activeIndex: '1',
      activeIndex2: '2',
      auth: authService
    }
  },
  computed: mapState(['currentUser', 'userMeta']),
  methods: {
    logOut: function () {
      this.auth.logout()
    }
  }

}
</script>
<style>

	.headerWrapper {
		background-color: rgb(50, 65, 87);
	}

	.header	{
		color: #fff;
		top: 0;
		left: 0;
		width: 100%;
		line-height: 80px;
		z-index: 100;
		position: relative;
	}

	.container {
		max-width: 1200px;
		margin:  0 auto;
	}

	.header .container {
		padding-left: 15px;
		padding-right: 15px;
	}

	.home-link {
		padding-left:  0px;
	}

	.logo {
	  height:  30px;
	  margin-top:  15px;
	}

	.el-menu-item a {
		color:  white !important;
		text-decoration:  none;
	}

	.el-menu-item a.router-link-active {
		text-decoration:  none;
	}

	.el-menu-item a span {
		border-bottom:  1px solid transparent;
	}

	.el-menu-item a.router-link-active span {
		border-bottom:  1px solid white;
	}

	.el-submenu {
		float:  right !important;
	}

	.el-submenu .el-menu-item a {
		color: black;
	}

	.el-menu--horizontal > .el-menu-item:hover, .el-menu--horizontal > .el-submenu:hover .el-submenu__title, .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
		border-bottom:  transparent !important;
	}

</style>


// WEBPACK FOOTER //
// Header.vue?19f8a4d1